import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.55, delay, ease: "easeOut" }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, copy, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    {eyebrow && <div className="eyebrow mb-4">{eyebrow}</div>}
    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.08]">{title}</h2>
    {copy && <p className="mt-5 text-base md:text-lg text-muted-foreground leading-relaxed">{copy}</p>}
  </div>
);

export const PageHero = ({ eyebrow, title, copy, children, img }) => (
  <section className="relative overflow-hidden border-b grain">
    <div className="absolute inset-0 grid-lines opacity-40 [mask-image:radial-gradient(ellipse_at_top_left,black,transparent_70%)]" />
    <div className="container-x relative py-20 md:py-28 grid lg:grid-cols-12 gap-10 items-center">
      <div className={img ? "lg:col-span-7" : "lg:col-span-9"}>
        <Reveal>
          <div className="eyebrow mb-5">{eyebrow}</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.04]">{title}</h1>
          {copy && <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed">{copy}</p>}
          {children && <div className="mt-8 flex flex-wrap gap-3">{children}</div>}
        </Reveal>
      </div>
      {img && (
        <Reveal delay={0.15} className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -inset-4 rounded-[2rem] bg-brand opacity-20 blur-2xl" />
            <img src={img} alt="" className="relative aspect-[4/3] w-full rounded-[1.75rem] object-cover border" />
          </div>
        </Reveal>
      )}
    </div>
  </section>
);

export const StatusPill = ({ status }) => {
  const map = {
    Live: "bg-[#10b981]/15 text-[#059669] dark:text-[#34d399]",
    Demo: "bg-[#06b6d4]/15 text-[#0891b2] dark:text-[#22d3ee]",
    Beta: "bg-[#f59e0b]/15 text-[#b45309] dark:text-[#fbbf24]",
    Roadmap: "bg-[#7c3aed]/15 text-[#6d28d9] dark:text-[#a78bfa]",
    "Coming Soon": "bg-foreground/10 text-muted-foreground",
  };
  return <span className={`inline-flex items-center rounded-full px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider ${map[status] || map["Coming Soon"]}`}>{status}</span>;
};
